export default __webpack_public_path__ + "static/media/tutorial-01.178d7e92.jpg";